

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Components } from 'ottuxlib';
import OttawaHeader = Components.OttawaHeader;
import OttawaFooter = Components.OttawaFooter;
import { IsMobile } from '@/utility/Context';
import OttawaTopButton = Components.OttawaTopButton;

@Component({
  components: {
    OttawaHeader,
    OttawaFooter,
    OttawaTopButton,
  },
})
export default class App extends Vue {
  @Prop({ type: String, default: process.env.VUE_APP_OTTAWA_CA_URL })
  public apiServer!: string;

  private isMobile: boolean = IsMobile();

  public get getCurrentLang() {
    return this.$i18n.locale;
  }

  private get getBreadcrumbs() {
    return {
      labels: this.$store.state.labels,
      links: this.$store.state.links,
    };
  }

  private async switchLang(newLang: string) {
    this.$i18n.locale = newLang;
    const scrollPos = window.scrollY ? window.scrollY : 0;
    this.$router.push({
      name: this.$router.currentRoute.name === null ? '' : this.$router.currentRoute.name,
      params: {
        lang: newLang,
      },
    });
    document.documentElement.lang = newLang;
    setTimeout(() => {
      window.scroll(0, scrollPos);
    }, 100);
  }

  private mounted() {
    window.addEventListener('resize', () => {
      this.isMobile = IsMobile();
    });
  }
}
